import { Component, Input } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-datepicker-filter',
  templateUrl: './datepicker-filter.component.html',
  styleUrls: ['./datepicker-filter.component.css']
})
export class DatepickerFilterComponent extends BaseFilterCellComponent{
  //@Input() public filter!: CompositeFilterDescriptor;
  @Input() public filter: any;
  @Input() public field: any;

  constructor(filterService: FilterService, private datepipe: DatePipe) { super(filterService); }

  public List: string[] = ["Date","Month","Year"]
  public viewType = "month";
  public formatType = "dd MMM yyyy";
  public selectedItem: string = this.List[0];
  public val!: Date|null;
  public showClear: boolean = false;

  dateChange(val:Date) {
    this.showClear = true;
    this.filterService.filter(
      this.removeFilter(this.field)
    );
    let valueField = this.selectedItem=="Date" ? this.datepipe.transform(val, 'yyyy-MM-dd') : this.selectedItem=="Month" ? this.datepipe.transform(val, 'yyyy-MM') : this.datepipe.transform(val, 'yyyy')
    let valueField2 = this.selectedItem=="Date" ? this.datepipe.transform(val, 'yyyy.MM.dd') : this.selectedItem=="Month" ? this.datepipe.transform(val, 'yyyy.MM') : valueField
    let temp = [{
        field: this.field,
        operator: 'contains',
        value: valueField
      },
      {
        field: this.field,
        operator: 'contains',
        value: valueField2
      }]
    let filter = this.filter ? this.filter.filters : []
    filter.push({
      filters: temp,
      logic: 'or'
    })
    this.applyFilter({
      filters: filter,
      logic: 'and'
    });
  }

  public dropdownChange(val: string) {
    this.val = null;
    val==this.List[0] ? this.viewType = "month" : val==this.List[1] ? this.viewType = "year" : this.viewType = "decade";
    val==this.List[0] ? this.formatType = "dd MMM yyyy" : val==this.List[1] ? this.formatType = "MMMM yyyy" : this.formatType = "yyyy";
  }

  public clearDate() {
    this.val = null;
    this.showClear = false;
    this.filterService.filter(
      this.removeFilter(this.field)
    );
  }
}